export default {
  auth: {
    login: {
      email: {
        title: 'Enter your email',
        input: {
          label: 'Enter your email address',
          description:
            'Please provide an email address we will use to communicate with you including all booking information.',
          placeholder: 'youremail@gmail.com',
        },
      },
      passwordText:
        'We will send you a one time passcode via email to proceed.',
      btnLogin: 'Continue',
      error: {
        loginFailed: 'Login failed. Please try again.',
        emailFormat: 'Wrong email format, try again',
        emailError:
          'Please enter the correct email address or call support as this account is already linked to {email}',
      },
    },
    checkCode: {
      title: 'Check your email',
      description: 'We have sent a unique code to ',
      wrongEmailTitle: 'Wrong email?',
      reEnterEmailLabel: 'Re-enter your email address',
      passcodeSubtitle: 'One time passcode',
      uniqueCodeText: 'You can resend the unique code in {count} seconds',
      btn: {
        resend: 'Resend',
        verify: 'Verify',
      },
      error: {
        wrongCode: 'Passcode may be incorrect or expired. Please try again.',
        notVerified: {
          title: 'Sorry, passcode not verified',
          description:
            'Too many incorrect attempts were made to enter the verification passcode.',
          button: 'Re-enter email',
        },
        expired: {
          title: 'Verification code has expired',
          description:
            'Unfortunately the verification code has expired, so you have to restart your booking again',
          button: 'Restart booking',
        },
      },
    },
    signUp: {
      title: 'Update details',
      subtitle: 'You can update your details below',
      firstNameInput: {
        label: 'First name(s)',
        placeholder: 'John',
      },
      lastNameInput: {
        label: 'Last name(s)',
        placeholder: 'Smith',
      },
      emailInput: {
        label: 'Email address',
      },
      marketingAgreementText:
        'I agree to receive personalised marketing emails.',
      signUpButton: 'Login',
      validationError: {
        invalidEmail: 'Please enter a valid email address.',
        maxLength: 'Max length is 255 characters',
        emptyName: "Name can't be empty",
      },
      error: {
        signUpError: 'An error ocurred',
        attempts: {
          title: 'Sorry, too many wrong attempts',
          description:
            '5 incorrect attempts were made to enter the verification code. Please try again in an hour',
          btn: {
            reEnter: 'Re-enter email',
            contact: 'Contact support',
          },
        },
      },
    },
    maintenance: {
      title: 'Maintenance underway',
      description:
        "We're sorry, the booking service is temporarily unavailable as a system update is being performed. Please check back later or Contact support.",
      note: 'Please return later or',
      btn: {
        support: 'Contact support',
      },
    },
    notFound: {
      title: '404 - Page not found',
      description:
        'The page you are looking for might have been removed or is temporarily unavailable.',
      descriptionMobile: 'Try again or browse other options.',
      btn: {
        returnToLounge: 'RETURN TO LOUNGE',
        support: 'Contact support',
      },
    },
  },
  lounge: {
    perPerson: 'per person',
    errors: {
      server: {
        title: 'Sorry, service is not available',
        description:
          'There might be an error in the system. Please try again or browse other options.',
        btn: {
          return: 'Return to lounges',
        },
      },
      capacity: {
        title: 'Lounge is at capacity',
        description: {
          known:
            "We're sorry, the lounge selected is at capacity at this time. You can try booking for a smaller number of guests or please check to see if another lounge is available.",
          notKnown:
            'Our apologies, but capacity of the lounge for the time slot you selected is',
        },
        solutions: {
          title: 'You can',
          points: [
            'Change number of guests',
            'Change time slots',
            'Find another lounge',
          ],
        },
        btn: {
          change: 'Change guests number',
          return: 'Return to lounges',
        },
      },
      unavailable: {
        title: 'Lounge is unavailable',
        description:
          "Sorry, but we're unable to fulfill your request to book the lounge at the moment. We apologize for the inconvenience caused. Please try again later or contact our customer support for further assistance. Thank you for your understanding.",
      },
      terminalsMismatch: {
        title: 'Terminals mismatch',
        description:
          'Please note, that the lounge you are booking is not in the terminal your flight is scheduled. Lounge terminal is at North Terminal. Flight departure terminal is from South Terminal. Do you still want to book this lounge even it is not in the terminal of departure?',
        btn: {
          return: 'Return to lounges',
          continue: 'Continue booking',
        },
      },
      noFlightInfoFound: {
        title: "Sorry, we can't find your flight",
        description:
          'Please, enter flight details manually. Be informed we are not able to validate if airport and terminal are matching.',
        btn: {
          return: 'Return to lounges',
          continue: 'Enter flight time',
        },
      },
    },
    topBarLinks: {
      backToLounge: 'BACK TO ',
      faqs: 'FAQs',
      back: 'BACK',
    },
  },
  booking: {
    flightAndGuests: {
      title: 'Flight and guests entry',
      amendTitle: 'Booking amendments',
    },
    flightDetails: {
      title: 'Flight details',
      localeValue: 'en',
      warning: 'Pass can be used 3 hours prior to a flight',
      dateInput: {
        label: 'Date',
        placeholder: 'Flight date',
      },
      flightTimeInput: {
        label: 'Flight Time',
      },
      numberInput: {
        label: 'Flight number',
        placeholder: 'E.g. EZY123',
      },
      time: {
        label: 'Time of flight',
      },
      errors: {
        invalid_date: 'Must provide date of flight.',
        invalid_dateflight:
          'Flight details not recognised. Please check and try again.',
        invalid_flight:
          'Flight details not recognised. Please check and try again.',
      },
    },
    guestDetails: {
      title: "Who's coming?",
      shortDescription: 'Maximum group size is {guests}.',
      description:
        'Maximum group size is {guests}, excluding {excluded}. Please check availability for lounge-specific restrictions on number of {excluded}.',
      adults: {
        label: 'Adults',
        description: 'Ages {age}',
      },
      children: {
        label: 'Children',
        description: 'Ages {age}',
      },
      infants: {
        label: 'Infants',
        description: 'Ages {age}',
      },
      seniors: {
        label: 'Seniors',
        description: 'Ages {age}',
      },
      loungeTerms: {
        line1: 'Refer to ',
        link: 'lounge conditions',
        line2: 'for age restrictions',
      },
      errors: {
        capacity:
          'The maximum capacity of the lounge is a total of {guests} guests. Change number of guests.',
      },
    },
    availableSlots: {
      title: 'Arrival time',
      description:
        'Timeslots are shown in the time zone of the lounge location',
      placeholder: 'Select time',
      arrivalDescription: 'This is the time you will arrive at the lounge.',
      stayTime: {
        line1: 'As your flight is at ',
        line2: ', your maximum stay is ',
        line3: '3 hours prior',
      },
      totalPrice: {
        title: 'Total price',
        titleAmend: 'Additional price to pay',
        titleRefund: 'Amount to receive',
        samePrice: 'No additional fee required',
      },
      panelInfoHeader: {
        date: 'Date',
        flightTime: 'Time of flight',
        flightNumber: 'Flight number',
      },
      busynessIndicator: {
        title: 'Will it be busy?',
        lowestLabel: 'Unlikely',
        highestLabel: 'Very likely',
        defaultTooltipMessage:
          'Peak hours may affect capacity. Select arrival time for lounge capacity information',
        tooltipMessage: [
          'Lounge is typically not close to capacity',
          'This lounge is typically at a low occupancy.',
          'This lounge may be only moderately busy',
          'This lounge may be close to capacity. Pre-book your visit to secure your spot.',
          'This lounge may be at capacity. Pre-book your visit to secure your spot',
        ],
        errorTooltipMessage:
          'Lounge capacity information is currently unavailable',
        messageOnError:
          ' Lounge capacity information is currently unavailable. Pre-book a visit to secure your spot.',
        messageBeforeSelected: 'Select arrival time for capacity information',
      },
      hsbcCancelationPolicy: {
        title: 'Please note a pre-booking fee applies for HSBC cardholders',
        descriptionLine1:
          "For HSBC Premier cardholders, this pre-booking fee will be added on top of your and your guest(s)'s visit passes fees. When you arrive at the lounge you will still be required to pay £24 per visitor.",
        descriptionLine2:
          'For HSBC Premier World Elite cardholders, please note whilst you do receive free visit passes for yourself and any additional cardholders (i.e., not your guests) - the pre-booking fee will act as a separate fee, and also apply to you and your guests. When you arrive at the lounge any guests who are not the primary or additional cardholder will be required to pay £24 per visitor.',
      },
      cancellationPolicy: {
        title: 'Cancellation policy',
        descriptionLine1:
          'Cancel up to {time} hours before your booking to receive a full refund. Bookings cannot be cancelled or amended within {time} hours of booking arrival time, including new bookings made within that time range.',
        descriptionLine2:
          'Please confirm details are correct before making payment.',
      },
      btn: 'CONFIRM',
      amendBtn: 'PROCEED WITH CHANGES',
      errors: {
        airportMismatch: {
          title: "Airports don't match",
          description:
            'The lounge you are booking is not in the same airport your flight is scheduled to depart from.',
        },
        terminalMismatch: {
          title: "Terminals don't match",
          description:
            'The lounge you are booking is not in the same terminal your flight is scheduled to depart from.',
          continueBtn: 'CONTINUE BOOKING',
        },
        noAmendChanges: {
          title: 'Select other details',
          description:
            'You haven’t made any changes. Amend your booking or exit the amendment',
          btn: 'AMEND BOOKING',
        },
        confirmation: 'Do you still want to go ahead with this booking?',
        arrivalTime: 'Select arrival time',
        availabilityUnknown: {
          title: 'Availability is unknown',
          description:
            'Our apologies, but capacity for time slot you selected is unknown.',
          solutions: {
            title: 'You can',
            points: [
              'change number of guests',
              'change time slot',
              'find another lounge',
            ],
          },
          endText: 'Or try again later',
        },
        btn: {
          edit: 'Edit booking',
          return: 'Return to lounges',
        },
      },
    },
    declineAmend: {
      title:
        "We're sorry, this booking cannot be amended within {time} hours of booking arrival time.",
    },
    confirmBooking: {
      title: 'Booking summary',
      amendTitle: 'Booking amendment summary',
      text: 'Please confirm details are correct before making payment.',
      btn: 'Go to payment',
      btnNext: 'Next',
      loadingModal: {
        title: 'Page is loading',
        description:
          'Please wait while the page is loading. These might take a few seconds to complete. Your patience is appreciated',
      },
    },
    entitlements: {
      title: 'Pre-book Entitlements',
      infoModal: {
        title: 'Pre-book Entitlements',
        text: 'The pre-book entitlements are being provided to Platinum and Centurion cardmembers in the United Kingdom, courtesy of American Express. These entitlements allow cardmembers to pre-book at eligible United Kingdom Priority Pass lounges. When pre-booking at an eligible lounge, cardmembers will be able to use these pre-book entitlements to book for themselves and their guests.',
        btnClose: 'CLOSE',
      },
      loungeInfo: {
        entitlementsRemaining: 'entitlements remaining',
        unlimitedEntitlements: 'unlimited entitlements remaining',
        entitlementsUsed: 'Entitlements used',
      },
      countAndExpiryDate:
        'You have {count} pre-book entitlements remaining, valid until {date}',
      unlimitedEntitlements:
        'You have unlimited pre-book entitlements, valid until {date}',
      inputLabel:
        'Select the number of entitlements you would like to use for this booking',
    },
    payment: {
      amendmentPaymentPolicy:
        'You will be charged in full for the amendment to your existing booking and be refunded for the full amount of the original booking',
      btnGoPayment: 'Go to payment',
      title: 'Payment information',
    },
    confirmationPayment: {
      title: 'Booking confirmation',
      amendTitle: 'Booking amendment confirmation',
      processing: {
        beingProcessed: {
          title: 'Payment is being processed',
          description: {
            line1: 'Your payment for ',
            line2: 'is being processed.',
            line3:
              "Please don't refresh the page, it may take a few minutes to complete.",
          },
        },
        unsuccessful: {
          title: 'Payment is being unsuccessful',
          description:
            'Please, do not leave this screen neither close your browser until the action finishes ',
        },
      },
      outcome: {
        succesful: {
          title: 'Good news! Your booking has been confirmed',
          titleAmend: 'Good news! Your booking has been amended',
          refundExplainedLine1:
            'You will be refunded the full amount of your original booking.',
          refundExplainedLine2:
            'Your refund will be processed onto the payment card used to pay for the original booking within 10 working days.',
          refundText:
            ' You have decreased the number of guests from your booking. Your refund will be processed onto the payment card used to pay for the original booking within 10 working days.',
          reference: {
            label: 'Booking Reference',
          },
          emailConfirmationLabel: 'A confirmation email has been sent to',
          entitlementsRedeemed: 'Pre-book Entitlements redeemed',
          entitlementsRemaining:
            'You have {count} pre-book entitlements remaining.',
          unlimitedEntitlements: 'You have unlimited pre-book entitlements.',
          noEntitlementsRemaining:
            'You have no pre-book entitlements remaining.',
          description:
            'Our apologies, error occurred during the payment process and your payment was not processed. We kindly request you to either make a new booking or repeat your payment.',
          importantNotes: {
            title: 'Important Notes',
            notes: {
              one: 'Please remember to bring your booking reference number, boarding pass and photo ID along with your {membershipType} membership card or eligible access method for check in at the lounge.',
              two: 'Maximum stay is 3 hours prior to your flight time.',
              three:
                'Cancellation must be made at least {time} hours in advance of your visit date & time to receive a refund. No refund will be issued after this time.',
            },
            amendedNote:
              'You have been charged for in full for the amendment to your existing booking. The full amount of your original booking will be refunded onto the payment card used to pay for the original booking within 10 working days.',
          },
          btn: {
            download: 'DOWNLOAD',
            return: 'Return to lounge',
          },
        },
        notConfirmed: {
          title: "Your payment hasn't confirmed",
          description:
            'Our apologies, error occurred during the payment process and your payment was not processed. We kindly request you to either make a new booking or repeat your payment.',
          btn: {
            payment: 'Repeat payment',
            return: 'Return to lounge',
          },
        },
        delay: {
          title: 'Booking confirmation delay',
          description:
            'We are not able to confirm your booking yet, we will send you an email once your booking is confirmed',
          btn: 'Return to lounges',
        },
        delayError: {
          title: 'No confirmation received',
          description:
            'We are not able to confirm your booking yet, we will send you an email once your booking is confirmed',
          btn: 'Return to lounges',
        },
        declined: {
          title: 'Your booking has been declined',
          description:
            "Apologies for the delay in processing. Unfortunately, we couldn't confirm you booking. Please consider booking another time slot.",
          btn: {
            return: 'Return to lounges',
            select: 'Select another time',
          },
        },
      },
    },
    cancellation: {
      title: 'Booking Cancellation',
      description: 'You are about to cancel the booking, are you sure?',
      reference: 'Booking Reference:',
      btnCancel: 'CANCEL BOOKING',
      btnClose: 'CLOSE',
      policy: {
        title: 'Cancellation policy',
        description:
          'Cancel up to {time} hours before your booking to receive a full refund. Bookings cannot be cancelled or amended within {time} hours of booking arrival time, including new bookings made within that time range.',
      },
      unsuccesful:
        "We're sorry, this booking cannot be cancelled within {time} hours of booking arrival time",
      btn: 'Confirm',
      errors: {
        notFound: 'The booking cannot be found',
        alreadyCancelled: 'The booking has been already cancelled',
        notOwned:
          'Sorry, something went wrong with your booking, please try again later or contact support',
        failed:
          'Sorry, something went wrong with your booking, please try again later or contact support',
        notAllowed:
          "We're sorry, this booking cannot be cancelled within {time} hours of booking arrival time.",
        wrong:
          'Sorry, something went wrong with your booking, please try again later or contact supports',
        expiredBooking:
          'The date of the booking has expired and cannot be changed',
      },
      confirmation: {
        title: {
          Cancel: 'Your booking has been cancelled',
          Failed:
            'Your booking cancellation has failed, please contact our team',
          NotCancel:
            'Your booking could not be cancelled, please contact our team',
        },
        email: 'A confirmation email has been sent to',
        refund: {
          failed:
            'Refund attempt unsuccessful. Please contact your bank or card issuer for assistance.',
          successful:
            ' Your payment for this booking will be refunded within 10 days',
        },
        entitlementsRefund:
          'As you used your entitlements for this booking, they will be reinstated to your account.',
        entitlementsExpiration:
          'Please note that your existing entitlements will expire on {date}',
        entitlementsUsed:
          'As you used your entitlements for this booking, they will be reinstated to your account.',
        reBook:
          'If you didn’t mean to cancel, please re-book through {accountProvider}. We hope to see you next time.',
        moreInformation:
          'For more information, please visit our {faq:FAQs} page',
        loading: 'Loading',
      },
    },
    checkAvailability: {
      arrivalTitle: 'Arrival time selection',
      amendTitle: 'Arrival time amendment',
      notFoundError: 'Something went wrong, please try again',
      btn: 'CHECK AVAILABILITY',
    },
    failureBooking: {
      declined: {
        title: 'Your booking has been declined.',
        description:
          "We're sorry but during the payment process the capacity for the lounge changed and we are no longer able to confirm your booking. You will be refunded any payment made.",
        note: 'Please consider booking another time slot, or check to see if another lounge is available.',
        btn: {
          selectAnotherTime: 'SELECT ANOTHER TIME',
          returnToLounge: 'Return to lounges',
        },
      },
    },
    confirmationPDF: {
      title: 'Booking Confirmation',
      description: {
        line1: 'Good news! Your booking for',
        line2: 'at',
        line3: 'has been confirmed.',
      },
      bookingDetails: {
        title: 'Your booking details',
        reference: 'Booking reference:',
        date: 'Date:',
        flightNumber: 'Flight number:',
        timeOfArrival: 'Arrival time:',
      },
      guestDetails: {
        title: "Who's coming?",
        adults: 'Adults',
        children: 'Children',
        infants: 'Infants',
        seniors: 'Seniors',
      },
      entitlements: {
        redeemed: 'Pre-book Entitlement redeemed:',
        remaining: 'Pre-book entitlements remaining:',
        validUntil: 'Pre-book entitlements are valid until:',
      },
      price: 'Total',
      importantNotes: {
        title: 'Important Notes',
        checkInNote:
          'Please remember to bring your booking reference number, boarding pass and photo ID along with your {membershipType} membership card or eligible access method for check in at the lounge.',
        maximumStay: 'Maximum stay is 3 hours prior to your flight time.',
        cancelText:
          'Cancellation must be made at least {time} hours in advance of your visit date & time to receive a refund. No refund will be issued after this time. ',
        amendText: 'Please follow the link if you wish to ',
      },
      amendLink: 'Amend the booking',
      cancelLink: 'Click here to cancel your booking',
      forwardText: 'We look forward to seeing you there!',
      loadingText: 'Loading document...',
      error:
        'An error occurred while generating your booking confirmation! Please try again.',
    },
    failureAmendmentRefund: {
      title: 'Your booking amendments has been declined',
      description:
        "We're sorry during the amendment process the capacity for the lounge changed and we are no longer able to confirm your booking amendment. Your booking remains the same. If you still want to change your booking, please try again",
    },
  },
  fastTrack: {
    errors: {
      capacity:
        'The maximum capacity for Fast Track is a total of {guests} guests. Change number of guests.',
    },
    arrivalTimeDescription:
      'Timeslots are shown in the time zone of the Fast Track lane',
    importantNotes: {
      one: 'Please have your booking reference number, confirmation email, boarding pass, and passport handy to ensure smooth entry to the Fast Track lane.',
      two: 'If your confirmation email contains a scannable QR code, please ensure you have this ready to scan when you arrive at the Fast Track lane.',
      three:
        'Cancellation of your booking must happen at least 2 days in advance of your visit date in order to be elligible for a refund. No refunds will be issued after this time.',
    },
    policies: {
      cancellation:
        'Cancel up to 2 days before your Fast Track booking to receive a full refund. Fast Track bookings cannot be cancelled within 2 days of booking arrival time, including new bookings made within that time range. You are not able to amend a Fast Track booking; if you wish to change it, please cancel your original booking and then re-book.',
      terms: {
        line1: 'Refer to ',
        link: 'Fast Track conditions',
        line2: 'for age restrictions',
      },
      guests:
        'Maximum group size is {guests}, excluding infants. Please check availability for Fast Track specific restrictions on number of infants.',
    },
    timeSlotsDisclaimer:
      'This is the time you will arrive at the Fast Track lane.',
  },
  generic: {
    labels: {
      logo: 'App logo',
      downloadPdf: 'Download PDF',
      editBooking: 'Edit booking',
      selectTimeSlot: 'Select time slot',
      flightDate: 'Flight Date',
      flightNumber: 'Flight Number',
      flightTime: 'Flight Time',
      loungeName: 'Lounge name',
      codeInput: 'One time passcode',
      editButton: 'Edit button',
      loginEmail: 'Login email address',
      firstName: 'First name',
      lastName: 'Last name',
      adults: 'Adults',
      children: 'Children',
      infants: 'Infants',
      decrementAdults: 'Decrement Adults',
      incrementAdults: 'Increment Adults',
      selectedAdults: 'Selected Adults',
      decrementChildren: 'Decrement Children',
      incrementChildren: 'Increment Children',
      selectedChildren: 'Selected Children',
      decrementInfants: 'Decrement Infants',
      incrementInfants: 'Increment Infants',
      selectedInfants: 'Selected Infants',
      incrementEntitlements: 'Increment number of entitlements',
      decrementEntitlements: 'Decrement number of entitlements',
      selectedEntitlements: 'Selected number of entitlements',
      loading: 'Loading',
    },
    error: {
      unhandledError: {
        title: 'There was an error in the system',
        message: 'Please try again or browse other options.',
      },
      latestAppVersion:
        'There might be an error in the system. Please make sure to update to the latest version of the app.',
      webTitle:
        'There might be an error in the system. Please try again or browse other options.',
      loungeNoFound: "Sorry, we can't find the lounge you requested",
      tokenNoFound: 'Sorry, token is incorrect or missing',
    },
    branding: {
      MCAECustomBrandName: 'Mastercard Airport Experiences',
    },
  },
};
